<template>
  <ul class="nav nav--social">
    <li v-for="(menuItem, index) in socialMenu" :key="index">
      <a :href="menuItem.url" target="new" data-action="social" :data-platform="menuItem.label">
        <span :class="menuItem.icon"><span class="sr-only">{{menuItem.label}} Icon</span></span> <span class="hidden-xs">{{menuItem.label}}</span>
      </a>
    </li>
  </ul>
</template>

<script>
import { get } from 'vuex-pathify'

export default {
  computed: {
    socialMenu: get('Settings/socialMenu')
  }
}
</script>

<style scoped></style>
